import React, { Component } from "react";
import HistoricAccounting from "../../../components/HistoricAccounting/HistoricAccounting";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : OvertimeForm
Description : Componente que invoca al componente Overtime, para la consulta y creación de horas extra.
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente Overtime
================================================================================ */
class HistoricAccountingForm extends Component{
    render(){
        return(
            <HistoricAccounting/>  
        )   
    }
}

export default HistoricAccountingForm;